import React, { useEffect } from 'react';
import resumeData from '../data/resumeData';

const skillColors = {
  "C#": "#178600",
  "C/C++": "#f34b7d",
  "Python": "#3572A5",
  "HTML": "#e34c26",
  "CSS": "#563d7c",
  "JavaScript": "#f1e05a",
  "Java": "#b07219",
  "LESS": "#1d365d",
  "React": "#61dafb",
  "ASP.NET": "#9400ff",
  "CI/CD": "#4285F4",
  "AWS": "#FF9900",
  "SharePoint": "#0078D4",
  "Jira": "#0052CC",
  "Confluence": "#0052CC",
  "Selenium": "#43B02A",
  "Git": "#F05032",
  "GitHub": "#181717",
  "GitLab": "#FC6D26",
  "Windsurf": "#6366f1",
  "Full-Stack Development": "#6b7280",
  "CMS Integration": "#6b7280",
  "Agile Development": "#6b7280",
  "Testing Strategies": "#6b7280"
};

const getSkillColor = (skill) => {
  return skillColors[skill] || "#6b7280";
};

function GithubResume() {
  useEffect(() => {
    document.title = 'Sydney Ferris - GitHub Resume';
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen font-Nunito" style={{ backgroundColor: '#0d1117', color: '#c9d1d9' }}>
      {/* GitHub-style header */}
      <div style={{ backgroundColor: '#161b22', borderBottom: '1px solid #30363d', padding: '16px 0' }}>
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center gap-2 mb-3">
            <svg height="16" viewBox="0 0 16 16" version="1.1" width="16" style={{ fill: '#c9d1d9' }}>
              <path d="M8 0c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zm0-11c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5z"></path>
            </svg>
            <span style={{ color: '#58a6ff', fontSize: '20px' }}>{resumeData.github}</span>
            <span style={{ color: '#8b949e' }}>/</span>
            <span style={{ color: '#c9d1d9', fontSize: '20px', fontWeight: '600' }}>resume</span>
            <span style={{ marginLeft: 'auto', fontSize: '12px', color: '#8b949e' }}>Public</span>
          </div>
          
          {/* Navigation tabs */}
          <div className="flex gap-6" style={{ fontSize: '14px' }}>
            <button style={{ color: '#c9d1d9', fontWeight: '600', borderBottom: '2px solid #f78166', paddingBottom: '8px' }}>
              <svg height="16" viewBox="0 0 16 16" version="1.1" width="16" style={{ fill: '#c9d1d9', marginRight: '4px', verticalAlign: 'text-bottom' }}>
                <path d="M4.72 3.22a.75.75 0 011.06 1.06L2.06 8l3.72 3.72a.75.75 0 11-1.06 1.06L.47 8.53a.75.75 0 010-1.06l4.25-4.25zm6.56 0a.75.75 0 10-1.06 1.06L13.94 8l-3.72 3.72a.75.75 0 101.06 1.06l4.25-4.25a.75.75 0 000-1.06l-4.25-4.25z"></path>
              </svg>
              README.md
            </button>
            <button style={{ color: '#8b949e', paddingBottom: '8px' }}>
              <svg height="16" viewBox="0 0 16 16" version="1.1" width="16" style={{ fill: '#8b949e', marginRight: '4px', verticalAlign: 'text-bottom' }}>
                <path d="M8 4a4 4 0 100 8 4 4 0 000-8z"></path>
              </svg>
              Experience
            </button>
            <button style={{ color: '#8b949e', paddingBottom: '8px' }}>
              <svg height="16" viewBox="0 0 16 16" version="1.1" width="16" style={{ fill: '#8b949e', marginRight: '4px', verticalAlign: 'text-bottom' }}>
                <path d="M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"></path>
              </svg>
              Projects
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-6">
        {/* Repo header */}
        <div className="flex items-start justify-between mb-6">
          <div>
            <h1 className="text-3xl font-bold mb-2" style={{ color: '#c9d1d9' }}>{resumeData.name}</h1>
            <p className="mb-3" style={{ color: '#8b949e', fontSize: '14px' }}>{resumeData.title}</p>
            <div className="flex gap-4 text-sm" style={{ color: '#8b949e' }}>
              <span className="flex items-center gap-1">
                <svg height="16" viewBox="0 0 16 16" version="1.1" width="16" style={{ fill: '#8b949e' }}>
                  <path d="M8 .25a.75.75 0 01.673.418l1.882 3.815 4.21.612a.75.75 0 01.416 1.279l-3.046 2.97.719 4.192a.75.75 0 01-1.088.791L8 12.347l-3.766 1.98a.75.75 0 01-1.088-.79l.72-4.194L.818 6.374a.75.75 0 01.416-1.28l4.21-.611L7.327.668A.75.75 0 018 .25z"></path>
                </svg>
                {resumeData.experience.length} years experience
              </span>
              <span className="flex items-center gap-1">
                <svg height="16" viewBox="0 0 16 16" version="1.1" width="16" style={{ fill: '#8b949e' }}>
                  <path d="M5 5.372v.878c0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75v-.878a2.25 2.25 0 111.5 0v.878a2.25 2.25 0 01-2.25 2.25h-1.5v2.128a2.251 2.251 0 11-1.5 0V8.5h-1.5A2.25 2.25 0 013.5 6.25v-.878a2.25 2.25 0 111.5 0zM5 3.25a.75.75 0 01.75.75v.878a.75.75 0 01-1.5 0v-.878A.75.75 0 015 3.25zm5 0a.75.75 0 01.75.75v.878a.75.75 0 01-1.5 0v-.878A.75.75 0 0110 3.25z"></path>
                </svg>
                {resumeData.projects.length} projects
              </span>
              <span className="flex items-center gap-1">
                <svg height="16" viewBox="0 0 16 16" version="1.1" width="16" style={{ fill: '#8b949e' }}>
                  <path d="M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"></path>
                </svg>
                Updated {new Date().toLocaleDateString()}
              </span>
            </div>
          </div>
          <button
            onClick={handlePrint}
            className="no-print"
            style={{
              backgroundColor: '#238636',
              color: '#ffffff',
              border: '1px solid rgba(240,246,252,0.1)',
              padding: '5px 16px',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer'
            }}
          >
            Print PDF
          </button>
        </div>

        {/* README content */}
        <div style={{ backgroundColor: '#161b22', border: '1px solid #30363d', borderRadius: '6px', padding: '24px' }}>
          {/* Contact info */}
          <div className="mb-6" style={{ paddingBottom: '16px', borderBottom: '1px solid #30363d' }}>
            <div className="flex flex-wrap gap-4 text-sm" style={{ color: '#58a6ff' }}>
              <span>🌐 {resumeData.contact.website}</span>
              <span>🔗 {resumeData.contact.linkedin}</span>
              <span>💻 {resumeData.contact.github}</span>
            </div>
          </div>

          {/* Summary */}
          <div className="mb-6">
            <h2 className="text-xl font-bold mb-3" style={{ color: '#c9d1d9', borderBottom: '1px solid #30363d', paddingBottom: '8px' }}>
              <svg height="16" viewBox="0 0 16 16" version="1.1" width="16" style={{ fill: '#c9d1d9', marginRight: '4px', verticalAlign: 'text-bottom' }}>
                <path d="M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0114.25 16H1.75A1.75 1.75 0 010 14.25V1.75zm1.75-.25a.25.25 0 00-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25V1.75a.25.25 0 00-.25-.25H1.75zM1.5 6h6v6H1.5V6zm2 2h2v2H3.5V8zm4-4h6v2h-6V4zm0 2h6v2h-6V6zm0 2h6v2h-6V8zm0 2h6v2h-6v-2z"></path>
              </svg>
              About
            </h2>
            <p style={{ color: '#c9d1d9', lineHeight: '1.6' }}>{resumeData.summary}</p>
          </div>

          {/* Skills */}
          <div className="mb-6">
            <h2 className="text-xl font-bold mb-3" style={{ color: '#c9d1d9', borderBottom: '1px solid #30363d', paddingBottom: '8px' }}>
              <svg height="16" viewBox="0 0 16 16" version="1.1" width="16" style={{ fill: '#c9d1d9', marginRight: '4px', verticalAlign: 'text-bottom' }}>
                <path d="M8 4a4 4 0 100 8 4 4 0 000-8z"></path>
              </svg>
              Skills
            </h2>
            <div className="flex flex-wrap gap-2">
              {resumeData.skills.map((skill, index) => (
                <span
                  key={index}
                  className="px-3 py-1 rounded-full text-sm font-medium"
                  style={{
                    backgroundColor: getSkillColor(skill),
                    color: '#ffffff'
                  }}
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>

          {/* Experience */}
          <div className="mb-6">
            <h2 className="text-xl font-bold mb-3" style={{ color: '#c9d1d9', borderBottom: '1px solid #30363d', paddingBottom: '8px' }}>
              <svg height="16" viewBox="0 0 16 16" version="1.1" width="16" style={{ fill: '#c9d1d9', marginRight: '4px', verticalAlign: 'text-bottom' }}>
                <path d="M10.5 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm.601 4.427a.75.75 0 10-.688-1.336l-1.883.973a.75.75 0 00-.34.632v1.295a.75.75 0 001.5 0v-.855l1.611-.836zM8 10a2 2 0 100-4 2 2 0 000 4z"></path>
              </svg>
              Experience
            </h2>
            {resumeData.experience.map((exp, index) => (
              <div key={index} className="mb-4" style={{ marginBottom: '16px' }}>
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <h3 className="font-semibold" style={{ color: '#58a6ff', fontSize: '16px' }}>{exp.title}</h3>
                    <p style={{ color: '#8b949e', fontSize: '14px' }}>{exp.company} • {exp.location}</p>
                  </div>
                  <span style={{ color: '#8b949e', fontSize: '12px', backgroundColor: '#21262d', padding: '2px 8px', borderRadius: '12px' }}>
                    {exp.startDate} – {exp.endDate}
                  </span>
                </div>
                <ul style={{ color: '#c9d1d9', paddingLeft: '20px', fontSize: '14px' }}>
                  {exp.description.map((item, i) => (
                    <li key={i} style={{ marginBottom: '4px' }}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Education */}
          <div className="mb-6">
            <h2 className="text-xl font-bold mb-3" style={{ color: '#c9d1d9', borderBottom: '1px solid #30363d', paddingBottom: '8px' }}>
              <svg height="16" viewBox="0 0 16 16" version="1.1" width="16" style={{ fill: '#c9d1d9', marginRight: '4px', verticalAlign: 'text-bottom' }}>
                <path d="M8 1c-1.5 0-2.5.5-3.5 1.5L2 5v10h12V5l-2.5-2.5C10.5 1.5 9.5 1 8 1zm0 1.5c.8 0 1.5.3 2 .8L11.5 5H4.5L6 3.3c.5-.5 1.2-.8 2-.8z"></path>
              </svg>
              Education
            </h2>
            {resumeData.education.map((edu, index) => (
              <div key={index} className="mb-4">
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="font-semibold" style={{ color: '#58a6ff', fontSize: '16px' }}>{edu.degree}</h3>
                    <p style={{ color: '#8b949e', fontSize: '14px' }}>{edu.school} • {edu.location}</p>
                  </div>
                  <span style={{ color: '#8b949e', fontSize: '12px', backgroundColor: '#21262d', padding: '2px 8px', borderRadius: '12px' }}>
                    {edu.startDate} – {edu.endDate}
                  </span>
                </div>
                <div className="mt-2 text-sm" style={{ color: '#8b949e' }}>
                  {edu.gpa && <span className="mr-4">GPA: {edu.gpa}</span>}
                  {edu.honors && <span style={{ color: '#3fb950', fontWeight: '600' }}>{edu.honors}</span>}
                </div>
                {edu.courses && (
                  <div className="mt-3">
                    <p className="text-sm font-semibold mb-2" style={{ color: '#c9d1d9' }}>Relevant Coursework:</p>
                    <div className="flex flex-wrap gap-2">
                      {edu.courses.map((course, i) => (
                        <span
                          key={i}
                          style={{ backgroundColor: '#21262d', color: '#c9d1d9', padding: '2px 8px', borderRadius: '12px', fontSize: '12px' }}
                        >
                          {course}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Projects */}
          <div>
            <h2 className="text-xl font-bold mb-3" style={{ color: '#c9d1d9', borderBottom: '1px solid #30363d', paddingBottom: '8px' }}>
              <svg height="16" viewBox="0 0 16 16" version="1.1" width="16" style={{ fill: '#c9d1d9', marginRight: '4px', verticalAlign: 'text-bottom' }}>
                <path d="M2 2.5A2.5 2.5 0 014.5 0h8.75a.75.75 0 01.75.75v12.5a.75.75 0 01-.75.75h-2.5a.75.75 0 110-1.5h1.75v-2h-8a1 1 0 00-.714 1.7.75.75 0 01-1.072 1.05A2.495 2.495 0 012 11.5v-9zm10.5-1V9h-8c-.356 0-.694.074-1 .208V2.5a1 1 0 011-1h8zM5 12.25v3.25a.25.25 0 00.4.2l1.45-1.087a.25.25 0 01.3 0L8.6 15.7a.25.25 0 00.4-.2v-3.25a.25.25 0 00-.25-.25h-3.5a.25.25 0 00-.25.25z"></path>
              </svg>
              Projects
            </h2>
            {resumeData.projects.map((project, index) => (
              <div key={index} className="mb-4" style={{ marginBottom: '16px' }}>
                <h3 className="font-semibold mb-2" style={{ color: '#58a6ff', fontSize: '16px' }}>{project.name}</h3>
                <p style={{ color: '#c9d1d9', fontSize: '14px', marginBottom: '8px' }}>{project.description}</p>
                <div className="flex flex-wrap gap-2">
                  {project.technologies.map((tech, i) => (
                    <span
                      key={i}
                      style={{ backgroundColor: '#21262d', color: '#58a6ff', padding: '2px 8px', borderRadius: '12px', fontSize: '12px' }}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @media print {
          .no-print {
            display: none !important;
          }
          body {
            background: white !important;
            color: black !important;
          }
          @page {
            margin: 0.5cm;
          }
        }
      `}</style>
    </div>
  );
}

export default GithubResume;
